import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "is-flex is-justify-content-space-between is-align-items-center mb-4" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h3", { class: "title is-4 mb-0" }, "Events", -1)
const _hoisted_4 = {
  key: 0,
  class: "editor-event"
}
const _hoisted_5 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      (_ctx.events.length > 0)
        ? (_openBlock(), _createBlock("button", {
            key: 0,
            class: "button is-small is-danger",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clearEvents && _ctx.clearEvents(...args)))
          }, " Clear "))
        : _createCommentVNode("", true)
    ]),
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.events, (event) => {
      return (_openBlock(), _createBlock("div", {
        key: event.method
      }, [
        _createVNode("p", null, [
          _createVNode("strong", null, _toDisplayString(event.method), 1)
        ]),
        (event.data)
          ? (_openBlock(), _createBlock("pre", _hoisted_4, _toDisplayString(event.data), 1))
          : (_openBlock(), _createBlock("hr", _hoisted_5))
      ]))
    }), 128))
  ]))
}